import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import HeroArea from '@uikit/composites/HeroArea/HeroArea';
import { HeroSize } from '@uikit/composites/HeroArea/consts';
import { ButtonAlign } from '../Button/consts';
import ButtonLink from '../ButtonLink/ButtonLink';
import { ClickableAction } from '../Clickable/consts';
import styles from './BenefitsOverviewHero.module.scss';
import type { BenefitsOverviewHeroProps } from './types';

const BenefitsOverviewHero = ({
  buttonText,
  description,
  headline,
  image,
  stageVariant,
  vimeoUrl,
}: BenefitsOverviewHeroProps) => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.base}>
      <HeroArea
        size={HeroSize.Large}
        stageBackground={stageVariant}
        image={image}
        skewedBottom={false}
        vimeoUrl={vimeoUrl}
      >
        <div className={styles.content}>
          <h1 className={styles.headline}>
            enercity+ <br />
            {headline}
          </h1>
          <p className={styles.description}>{description}</p>
          <ButtonLink
            actionType={ClickableAction.Anchor}
            anchor="vorteile"
            align={ButtonAlign.Center}
            icon="action/arrow-down"
            sizeVariant={isMobile ? 'medium' : 'large'}
            disableTransition
            className={styles.anchor}
          >
            {buttonText}
          </ButtonLink>
        </div>
      </HeroArea>
    </div>
  );
};

export default BenefitsOverviewHero;
